import React, { useState } from "react";
import PropTypes from 'prop-types';
import RulesRow from './rules_row';
import RuleModal from './rules_modal/main';

import './styles/main';


function RulesManagement(props) {
  const [showModal, toggleModal] = useState(false);

  return (
    <div className="manage-rules">
      <h2>Manage Rules for {BF.fx.brandfolder().name}</h2>
      <hr />
      <a onClick={() => toggleModal(!showModal)}>
        <span className="bff-plus add-rule" />
        {t('Add Rule')}
      </a>
      <div className="headers">
        <h3 className="fifteen">{t("Rule")}</h3>
        <h3 className="twenty">{t("Trigger")}</h3>
        <h3 className="thirty">{t("Action")}</h3>
        <h3 className="seven center">{t("Enforce")}</h3>
        <h3 className="five center">{t("Created")}</h3>
        <div className="ten center" />
        <div className="five" />
      </div>
      { props.rules.map((rule) => (
        <div className="rule-row" key={rule.key}>
          <RulesRow rule={rule} />
        </div>
      ))
      }
      { showModal ? <RuleModal /> : null }
    </div>
  );
}

RulesManagement.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default RulesManagement;
